/* eslint-disable @typescript-eslint/no-floating-promises */
import merge from 'lodash/merge';
import App from './views/App.svelte';
import CategoryService from './services/category.service';
import ServiceService from './services/service.service';
import ServiceProvider from './services/service.provider';
import DataProvider from './services/data.provider';
class CategoryServiceApp {
    constructor(options) {
        this.options = options;
    }
    mount() {
        try {
            this.prepareOptions();
            this.dataProvider = new DataProvider(this.options);
            const categoryService = new CategoryService(this.dataProvider);
            const serviceService = new ServiceService(this.dataProvider);
            this.serviceProvider = new ServiceProvider(categoryService, serviceService);
            this.createInstance();
        }
        catch (e) {
            console.log(e);
        }
    }
    createInstance() {
        new App({
            target: this.targetElement,
            props: {
                serviceProvider: this.serviceProvider,
                dataProvider: this.dataProvider
            }
        });
    }
    get targetElement() {
        const { el } = this.options;
        const element = document.querySelector(el);
        if (null === element) {
            throw new Error("The container for displaying category services does not exist");
        }
        return element;
    }
    // OPTIONS
    prepareOptions() {
        this.options = merge({}, {
            el: null,
            showSiteUrl: null,
            servicesGroupId: null,
            structureGroupId: null,
            vocabularyGroupId: null,
        }, this.options);
    }
}
const appContainer = document.getElementById("category-service-module");
if (appContainer) {
    const showSiteUrl = appContainer.getAttribute("data-show-site-url") || "false";
    const servicesGroupId = appContainer.getAttribute("data-services-group-id") || "";
    const structureGroupId = appContainer.getAttribute("data-structure-group-id") || "";
    const vocabularyGroupId = appContainer.getAttribute("data-vocabulary-group-id") || "";
    const categroyServiceApp = new CategoryServiceApp({
        el: "#category-service-module",
        showSiteUrl,
        servicesGroupId,
        structureGroupId,
        vocabularyGroupId,
    });
    void categroyServiceApp.mount();
}
